import { Alert, AlertIcon, AlertProps } from 'src/components/ui';
import { FC } from 'react';

const AlertMessage: FC<AlertProps> = ({ children, ...props }) => {
	return (
		<Alert borderRadius="md" fontSize="sm" {...props}>
			<AlertIcon />
			{children}
		</Alert>
	);
};

export default AlertMessage;
